import React, { useState } from 'react';

import ArrowBackIcon from '../../../assets/arrow-back-icon';
import { RouteOriginToDestination } from './origin-destination-list-item';
import RatingReview from './rating-review';
import Modal from '../../../components/modal';
import CommentIcon from '../../../assets/comment-icon';
import ReviewSent from './review-sent';
import CreateReviewForm from './create-review-form';

const CreateReviewButton = ({ onCreateReview }) => {
  return (
    <button
      onClick={onCreateReview}
      className="text-body2 text-primary-500 text-left font-medium w-full justify-center items-center flex gap-2 bg-[#F2FAF7] border border-[#ACDEC7] rounded-lg px-3 py-2"
    >
      <CommentIcon />
      Buat Ulasan
    </button>
  );
};

const SeeReview = ({
  onBack,
  companyName,
  busType,
  busClass,
  onCreateReview,
  origin,
  destination,
  totalRate,
  rateAverage
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <span
          className="flex flex-1 gap-4 justify-between lg:justify-start items-center cursor-pointer"
          onClick={onBack}
        >
          <div className="flex gap-2">
            <ArrowBackIcon />
            <span className="text-body1 font-bold md:text-2xl leading-[150%] md:leading-[100%] text-left">
              {companyName}
            </span>
          </div>
          <div className="flex flex-col lg:flex-row justify-center items-end lg:items-center gap-1">
            <span className="flex text-left text-sm text-white px-2 py-0.5 bg-primary-500 rounded-full">
              {busType}
            </span>
            <span className="flex text-left text-sm text-white px-2 py-0.5 bg-gray-500 rounded-full">
              {busClass}
            </span>
          </div>
        </span>
        <div className="hidden lg:block">
          <CreateReviewButton onCreateReview={onCreateReview} />
        </div>
      </div>
      <RouteOriginToDestination origin={origin} destination={destination} />
      <div className="block lg:hidden">
        <CreateReviewButton onCreateReview={onCreateReview} />
      </div>
      <hr />
      <div className="max-h-[80%]">
        <RatingReview totalRate={totalRate} rateAverage={rateAverage} isShowAll={true} />
      </div>
    </div>
  );
};

const ReviewModal = ({
  companyName,
  busClass,
  busType,
  onBack,
  origin,
  destination,
  isCreateReviewForm,
  transportId,
  rateAverage,
  totalRate
}) => {
  const [isCreateReview, setIsCreateReview] = useState(isCreateReviewForm);
  const [isReviewSent, setIsReviewSent] = useState(false);

  if (isReviewSent) {
    return (
      <ReviewSent
        onBack={() => {
          setIsReviewSent(false);
          setIsCreateReview(false);
        }}
      />
    );
  }

  return (
    <Modal>
      <div className="flex w-[90%] max-h-[90%] lg:h-auto lg:w-[50%] flex-col bg-white p-6 border rounded-lg overflow-auto">
        {isCreateReview ? (
          <CreateReviewForm
            companyName={companyName}
            busType={busType}
            busClass={busClass}
            onBack={() => {
              if (isCreateReviewForm) {
                onBack();
              } else {
                setIsCreateReview(false);
              }
            }}
            onSentReview={() => setIsReviewSent(true)}
            origin={origin}
            destination={destination}
            transportId={transportId}
          />
        ) : (
          <SeeReview
            companyName={companyName}
            busType={busType}
            busClass={busClass}
            onBack={onBack}
            onCreateReview={() => setIsCreateReview(true)}
            origin={origin}
            destination={destination}
            totalRate={totalRate}
            rateAverage={rateAverage}
          />
        )}
      </div>
    </Modal>
  );
};

export default ReviewModal;
